// src/components/WorkerEventsTable.jsx
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  StarIcon,
  TagIcon,
  TicketIcon,
  MusicalNoteIcon,
  UserGroupIcon
} from "@heroicons/react/24/solid";

function WorkerEventsTable({ events, onSort, renderSortIcon }) {
  // Function to render category icon, similar to GuestListPage
  const renderCategoryIcon = (category) => {
    switch (category) {
      case "VIP":
        return <StarIcon className="h-4 w-4 text-yellow-500" title="VIP" />;
      case "BACKSTAGE":
        return <TagIcon className="h-4 w-4 text-purple-500" title="Backstage" />;
      case "ARTIST":
        return <MusicalNoteIcon className="h-4 w-4 text-purple-500" title="Artist" />;
      case "STAFF":
        return <UserGroupIcon className="h-4 w-4 text-purple-500" title="Staff" />;
      case "REGULAR":
      default:
        return <TicketIcon className="h-4 w-4 text-gray-400" title="Regular" />;
    }
  };

  return (
    <div>
      {/* Заголовок таблицы */}
      <div
        className="
          grid
          grid-cols-[1fr_4fr_2fr]
          items-center
          font-semibold
          gap-2
          border-b border-gray-200
          py-2
        "
      >
        <div
          className="text-center cursor-pointer flex justify-center items-center px-2 text-sm"
          onClick={() => onSort("state")}
        >
          State
          <span className="ml-1 text-gray-600 text-sm" style={{ fontSize: "11px" }}>
            {renderSortIcon("state")}
          </span>
        </div>
        <div
          className="text-center cursor-pointer flex justify-center items-center px-2 text-sm"
          onClick={() => onSort("name")}
        >
          Event Title
          <span className="ml-1 text-gray-600 text-sm" style={{ fontSize: "11px" }}>
            {renderSortIcon("name")}
          </span>
        </div>
        <div
          className="text-center cursor-pointer flex justify-center items-center px-2 text-sm"
          onClick={() => onSort("date")}
        >
          Date
          <span className="ml-1 text-gray-600 text-sm" style={{ fontSize: "11px" }}>
            {renderSortIcon("date")}
          </span>
        </div>
      </div>

      {/* Список событий */}
      {events.map((event) => (
        <Link
          to={`/worker/events/${event.id}/guest-list`}
          key={event.id}
          className="
            grid
            grid-cols-[1fr_4fr_2fr]
            items-center
            border-b border-gray-200
            divide-x divide-gray-200
            p-2
            hover:bg-gray-100
            transition duration-200
            cursor-pointer
          "
        >
          <div className="flex items-center space-x-2 px-2">
            <span
              className={`
                w-2 h-2 rounded
                ${
                  event.state === "planned"
                    ? "bg-blue-500"
                    : event.state === "confirmed"
                    ? "bg-green-500"
                    : event.state === "cancelled"
                    ? "bg-red-500"
                    : "bg-gray-300"
                }
              `}
            />
            <span className="text-sm">{event.state || "unknown"}</span>
          </div>
          <div className="text-base font-medium text-black px-2 flex items-center">
            {event.category && renderCategoryIcon(event.category)}
            <span className={event.category ? "ml-1" : ""}>{event.name}</span>
          </div>
          <div className="text-sm font-medium text-gray-600 text-center px-2">
            {event.start_time
              ? new Date(event.start_time).toLocaleDateString("en-US", {
                  weekday: "short",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })
              : "Not specified"}
          </div>
        </Link>
      ))}
    </div>
  );
}

WorkerEventsTable.propTypes = {
  events: PropTypes.array.isRequired,
  onSort: PropTypes.func.isRequired,
  renderSortIcon: PropTypes.func.isRequired,
};

export default WorkerEventsTable;